<template>
  <div
    class="tw-fixed tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-z-30 tw-text-center"
  >
    <div
      @click.stop=""
      class="tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-bg-mainbg1 tw-opacity-70"
    ></div>
    <div
      ref="taskWrap"
      class="tw-absolute tw-top-0 md:tw-top-[30px] tw-left-[30px] tw-bottom-[30px] tw-right-[30px] tw-text-2xl"
    >
      <div
        class="tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-flex tw-justify-center tw-items-center"
      >
        <div class="tw-relative tw-w-[640px] tw-h-[480px]" :style="wrapStyle">
          <div class="tw-absolute tw-top-[16px] tw-right-[16px] tw-z-10">
            <CloseX size="25px" @click="$emit('close')" />
          </div>
          <div
            class="tw-relative tw-top-0 tw-left-0 tw-w-[640px] tw-h-[480px] tw-bg-mainbg1 tw-border-2 tw-border-solid tw-border-primary tw-rounded-3xl tw-p-[10px] tw-text-primary"
          >
            <SpellingGameEnd v-if="saveStatus != 0" @close="$emit('close')" />
            <ActivityIntro
              v-else-if="screen == 'intro'"
              :user-full-name="$currentUser.value?.fullName"
            />
            <ActivityGame v-else-if="screen == 'game'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { sfCurrentActivityScreen } from "@/state/sfActivityState";
import { SfActivityScreen } from "@/types/sfActivityTypes";
import { defineComponent } from "vue";
import ActivityIntro from "./activity-screens/ActivityIntro.vue";
import ActivityGame from "./activity-screens/ActivityGame.vue";
import { sfDestroyActivity, sfCreateActivity } from "@/state/sfActivityState";
import SpellingGameEnd from "./activity-components/SpellingGameEnd.vue";
import { spellingActivitySaveStatus } from "@/state/spellingGameState";
import CloseX from "@/components/ui/CloseX.vue";
import { preventScroll } from "@/state/appState";

export default defineComponent({
  components: { ActivityIntro, ActivityGame, SpellingGameEnd, CloseX },
  emits: ["close"],
  data() {
    return {
      currentScale: 1,
    };
  },
  computed: {
    wrapStyle(): any {
      const scaleS = "scale(" + this.currentScale + ")";
      return {
        MsZoom: this.currentScale,
        MozTransform: scaleS,
        OTransform: scaleS,
        WebkitTransform: scaleS,
        transform: scaleS,
      };
    },
    saveStatus(): number {
      return spellingActivitySaveStatus.value;
    },
    screen(): SfActivityScreen {
      return sfCurrentActivityScreen.value;
    },
  },
  mounted() {
    sfCreateActivity();
    window.addEventListener("resize", this.refreshScale);
    this.refreshScale();
    preventScroll(true);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.refreshScale);
    sfDestroyActivity();
    preventScroll(false);
  },
  methods: {
    refreshScale() {
      const wrap = this.$refs.taskWrap as HTMLElement;
      this.currentScale = Math.min(
        wrap.offsetWidth / 640,
        wrap.offsetHeight / 480,
      );
    },
  },
});
</script>
